import ComponentElement from 'components/component-element';
import {createElement} from 'methods/utils';

function Radio($element, options = {}) {
    ComponentElement.call(this, $element, options);

    this.$input = this.$element.querySelector('input[type="radio"]');

    Object.defineProperty(this, 'checked', {
        get: this.getChecked.bind(this),
        set: this.setChecked.bind(this),
    });

    if (typeof this.options.checked != 'undefined') {
        this.checked = this.options.checked;
    }
}

Radio.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(Radio.prototype, 'constructor', {
    value: Radio,
    enumerable: false,
    writable: true,
});

Radio.prototype.getChecked = function() {
    return this.$input.checked;
}

Radio.prototype.setChecked = function(value) {
    this.$input.checked = value;
}

Radio.make = function(options = {}) {
    const $element = createElement(
        `<div class="Radio">
            <label>
                <input type="radio" name="${options.name || ''}" value="${options.value || ''}">
                <div class="Radio__circle"></div>
                <span class="Radio__title">${options.title || ''}</span>
            </label>
        </div>`
    );

    return new Radio($element, options);
}

export default Radio;
